<form [formGroup]="form" *ngIf="!isLoading else loadingAnimation">
    <div class="entries"
         formArrayName="entries">
        <ng-container *ngFor="let item of array('entries').controls; let i = index;">
            <div class="entry_row" [formGroupName]="i">
                <ng-container [ngTemplateOutlet]="itemRow"
                              [ngTemplateOutletContext]="{index:i}">
                </ng-container>
            </div>
        </ng-container>
    </div>
    <ng-container *ngIf="array('entries').controls.length === 0 then noItems"></ng-container>
    <app-button *ngIf="hasMultiple" type="primary" icon="fa-plus"
                (clicked)="addItem()">{{ 'generic.buttons.add' | translate }}
    </app-button>
</form>

<ng-template #itemRow let-index='index'>
    <div class="header">
        <h5>{{ 'admin.strain.tickets.reports.modal.step3.measurement' | translate }} {{ index + 1 }}</h5>
        <div class="buttons">
            <app-icon *ngIf="hasMultiple"
                      type="info"
                      library="fontawesome"
                      variant="fa-clone"
                      [placeholder]="'generic.buttons.duplicate' | translate"
                      (click)="onDuplicate(index)"></app-icon>
            <app-icon *ngIf="hasSampleBoards"
                      type='warning'
                      library="fontawesome"
                      variant="fa-download"
                      [placeholder]="'admin.strain.tickets.reports.modal.step3.sampleBoardLoad.title' | translate"
                      (click)="onLoadFromSampleBoardClicked(index)"></app-icon>
            <app-icon type="danger"
                      library="fontawesome"
                      variant="fa-trash"
                      [placeholder]="'generic.buttons.delete' | translate"
                      (click)="removeItem(index)"
                      [class.hidden]="array('entries').controls.length <= 1">
            </app-icon>
        </div>
    </div>
    <div class="inputs">
        <app-textarea class="observations"
                      [formControl]="arrayControl(index, 'observations')"
                      [placeholder]="'admin.strain.tickets.reports.modal.step3.observations' | translate"
                      [label]="'admin.strain.tickets.reports.modal.step3.observations' | translate"
                      [showErrors]="showValidations || arrayControl(index, 'observations').touched && arrayControl(index, 'observations').invalid">
        </app-textarea>
        <br>
        <div class="gage" *ngFor="let gage of getGages(index); let i = index">
            <p>
                {{ i + 1 }}. {{ 'admin.strain.tickets.reports.modal.step3.gageType' | translate }}: <span
                class="blue-text">{{ gage.gage.type }}</span> |
                {{ 'admin.strain.tickets.reports.modal.step3.type.name' | translate }}:
                <span
                    class="blue-text">{{ 'admin.strain.tickets.reports.modal.step3.type.' + gage.gage.model | translate }}</span>
                |
                {{ 'admin.strain.tickets.reports.modal.step3.name' | translate }}: <span
                class="blue-text">{{ gage.name }}</span> |
                {{ 'admin.strain.tickets.reports.modal.step3.position.name' | translate }}:
                <span
                    class="blue-text">{{ 'admin.strain.tickets.reports.modal.step3.position.' + gage.position | translate }}</span>
            </p>
        </div>
    </div>
    <div class="images">
        <div class="top"><img [src]="getImageUrl(index)" *ngIf="getImageUrl(index) else frontImageText"></div>
        <div class="bottom"><img [src]="getImageUrl(index, true)" *ngIf="getImageUrl(index, true) else backImageText">
        </div>
    </div>
    <div class="settings">
        <app-icon library="fontawesome"
                  variant="fa-cog"
                  [placeholder]="'admin.strain.tickets.reports.modal.step3.gageConfiguration.title' | translate"
                  (click)="onEditClicked(index)"></app-icon>
    </div>
</ng-template>
<ng-template #noItems let-index='index'>
    <app-alert [responsive]="true"
               type="info"
               message="{{'admin.strain.registry.create.step4.info'| translate}}">
    </app-alert>
</ng-template>


<ng-template #loadingAnimation>
    <app-loading-spinner class="loader"></app-loading-spinner>
</ng-template>

<app-strain-gage-configuration-modal [gages]="gages"
                                     (save)="onGageSave($event)">
</app-strain-gage-configuration-modal>

<app-strain-sample-board-load-modal
    [sampleBoards]="sampleBoards"
    [isLoading]="isLoadingSampleBoardInstructions"
    (load)="onSampleBoardLoadRequested($event)">
</app-strain-sample-board-load-modal>

<ng-template #backImageText>
    <p>{{ 'admin.strain.tickets.reports.modal.step3.bottomImage' | translate }}</p>
</ng-template>

<ng-template #frontImageText>
    <p>{{ 'admin.strain.tickets.reports.modal.step3.topImage' | translate }}</p>
</ng-template>
